import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2aa3d078")

_pushScopeId("data-v-2aa3d078")
const _hoisted_1 = {
  key: 0,
  class: "phone_login flex_column_centers"
}
const _hoisted_2 = { class: "input_phone cinput" }
const _hoisted_3 = {
  key: 0,
  class: "error_text"
}
const _hoisted_4 = { class: "input_yzm cinput" }
const _hoisted_5 = { class: "flex_start_center" }
const _hoisted_6 = {
  key: 0,
  class: "error_text"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "phone_desc" }, " 如果您的手机号码尚未注册可牛账号，将使用该手机号码注册可牛账号 ", -1)
const _hoisted_8 = {
  key: 1,
  class: "chart_yzm"
}
const _hoisted_9 = { class: "chart_yzm_item_one" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "yzm_title" }, "请输入下方面板的字母及数字继续", -1)
const _hoisted_11 = { class: "yzm_action flex_start_center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "update_yzm_icon" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "换一换", -1)
const _hoisted_14 = { class: "chart_yzm_item_two" }
const _hoisted_15 = {
  key: 0,
  class: "error_text"
}
const _hoisted_16 = { class: "next_action" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.viewModel.isPhoneLogin)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewModel.form.phone = $event)),
            type: "text",
            placeholder: "输入手机号码",
            class: "form_input",
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valid('phone')))
          }, null, 544), [
            [_vModelText, _ctx.viewModel.form.phone]
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withId(() => [
              (_ctx.viewModel.err.phone)
                ? (_openBlock(), _createBlock("div", _hoisted_3, "请输入正确手机号"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewModel.form.yzm = $event)),
              type: "text",
              placeholder: "输入验证码",
              class: "form_input",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.valid('yzm')))
            }, null, 544), [
              [_vModelText, _ctx.viewModel.form.yzm]
            ]),
            _createVNode("span", {
              class: ['get_yzm', { disabled: _ctx.viewModel.isSendyzm }],
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.gainMsgYzm && _ctx.gainMsgYzm(...args)))
            }, _toDisplayString(_ctx.yzmText), 3)
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withId(() => [
              (_ctx.viewModel.err.yzm)
                ? (_openBlock(), _createBlock("div", _hoisted_6, "请输入正确验证码"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", {
          class: "to_login",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toLogin && _ctx.toLogin(...args)))
        }, "立即登录/注册"),
        _hoisted_7
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("img", {
              src: _ctx.viewModel.imgYzmUrl,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.gainImgYzm && _ctx.gainImgYzm(...args)))
            }, null, 8, ["src"]),
            _createVNode("div", {
              class: "update_action flex_column_centers",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.gainImgYzm && _ctx.gainImgYzm(...args)))
            }, [
              _hoisted_12,
              _hoisted_13
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.viewModel.form.imgYzm = $event)),
            placeholder: "请输入图片验证码",
            onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.valid('imgYzm')))
          }, null, 544), [
            [_vModelText, _ctx.viewModel.form.imgYzm]
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withId(() => [
              (_ctx.viewModel.err.imgYzm)
                ? (_openBlock(), _createBlock("div", _hoisted_15, "请输入正确图形验证码"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("span", {
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkImgYzm && _ctx.checkImgYzm(...args)))
          }, "下一步")
        ])
      ]))
})